import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { Search, Repeat, ShieldCheck, Ship } from "lucide-react";
import { Seo } from "@/components/common/Seo";
import { PAGES, CAPABILITIES, IMAGES, SEO } from "@/content/site";

const ICONS = { Search, Repeat, ShieldCheck, Ship };

export default function WhatWeDo() {
  const p = PAGES.whatWeDo;
  return (
    <div data-testid="page-what-we-do">
      <Seo title={SEO.whatWeDo.t} description={SEO.whatWeDo.d} path="/what-we-do" />
      <PageHero eyebrow={p.eyebrow} title={p.title} lead={p.lead} image={IMAGES.warehouse} />
      <section className="container-x py-16 lg:py-24">
        <div className="grid gap-8 md:grid-cols-2">
          {CAPABILITIES.map((cap, idx) => {
            const Icon = ICONS[cap.icon];
            return (
              <Reveal key={cap.title} delay={idx * 0.06}>
                <div className="flex h-full gap-5 rounded-2xl border border-slate-200/80 bg-white p-8 transition-all duration-300 hover:shadow-lg hover:shadow-azeka-navy/5">
                  <div className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-azeka-navy text-azeka-teal2">
                    <Icon className="h-6 w-6" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-ink-heading">{cap.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-ink-body">{cap.body}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>
    </div>
  );
}
